import React, { ComponentType, ReactNode } from "react";
import ReactDOM from "react-dom/client";
import GearstudioView from "./app";
import { GearstudioAuthProvider } from "./providers/GearstudioAuthProvider";
import { GearStudioDesignProvider } from "./providers/GearstudioDesignProvider";
import { GearstudioHistoryProvider } from "./providers/GearstudioHistoryProvider";
import { MessageProvider } from "@shared_components/providers/MessageProvider";
import { TrackingProvider } from "@shared_components/providers/TrackingProvider";
import "./index.css";
import "@shared_components/universal.css"; // universal styles
import { BrowserRouter } from "react-router-dom";

type ProviderType = ComponentType<{ children: ReactNode }>;
// Define the ComposeProviders component
interface ComposeProvidersProps {
  providers: ProviderType[];
  children: ReactNode;
}
const rootElement = document.getElementById("app_gearstudio");
if (!rootElement) {
  throw new Error("Failed to find root element with id 'app_gearstudio'.");
}

const root = ReactDOM.createRoot(rootElement);

const providers: ProviderType[] = [
  MessageProvider,
  GearstudioAuthProvider,
  GearstudioHistoryProvider,
  GearStudioDesignProvider,
];

const ComposeProviders: React.FC<ComposeProvidersProps> = ({ providers, children }) =>
  providers.reduceRight((acc, Provider) => <Provider>{acc}</Provider>, children);



root.render(
      <BrowserRouter>
          <TrackingProvider
              wanted_path={null}
              base_path="gearstudio"
              tracking_endpoint="/api/gearstudio/custom-tracking-event/"
          />
          <ComposeProviders providers={providers}>
              <GearstudioView />
          </ComposeProviders>
      </BrowserRouter>
);
